import { render, staticRenderFns } from "./MedIconBlock.vue?vue&type=template&id=33637394&scoped=true&"
import script from "./MedIconBlock.vue?vue&type=script&lang=js&"
export * from "./MedIconBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33637394",
  null
  
)

export default component.exports